import { observer } from 'mobx-react-lite'
import { RemoveDocumentRequestDialog } from '@/features/documents/RemoveDocumentRequestDialog'
import { type RemoveDocumentRequestDialogViewModel } from './RemoveDocumentRequestDialogViewModel'

export interface RemoveDocumentRequestDialogContainerProps {
  vm: RemoveDocumentRequestDialogViewModel
}

export const RemoveDocumentRequestDialogContainer = observer(
  function RemoveDocumentRequestDialogContainer({
    vm,
  }: RemoveDocumentRequestDialogContainerProps) {
    return (
      <RemoveDocumentRequestDialog
        showing={vm.modal.showing}
        onConfirm={vm.confirm}
        onDecline={vm.cancel}
        testId="remove-document"
      />
    )
  },
)
